import React, { Component } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import AuthenticatedRoutes from "./authenticatedRoutes";
import UnAuthenticatedRoutes from "./unAuthenticatedRoutes";

class Home extends Component {
  state = {};
  render() {
    return (
      <div>
        <AuthenticatedTemplate>
          <AuthenticatedRoutes />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <UnAuthenticatedRoutes />
        </UnauthenticatedTemplate>
      </div>
    );
  }
}

export default Home;
